<template>
  <div>
    <v-dialog v-model="modalErrorSaveOrder" persistent max-width="850">
      <v-card>
        <v-card-title
          >Se ha presentado el siguiente error: "{{
            errorSaveOrder
          }}".</v-card-title
        >
        <v-card-actions>
          <!--v-switch prepend-icon="mdi-printer" v-model="printReceiptSwitch" inset :label="printerOption()"></v-switch-->
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="primary"
            outlined
            @click="closeModalErrorSaveOrder()"
            :title="$t('Aceptar')"
          >
            {{ $t("Aceptar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="850">
      <v-card :key="key" class="overflow-hidden cobro__tarjeta">
        <div class="cobro__encabezado">
          <v-icon color="white" class="mr-2">mdi-cash-register</v-icon>
          <span class="cobro__titulo">{{ $t("total_to_pay") }}</span>
          <v-spacer></v-spacer>
          <span class="cobro__total">{{ $filters.currency(this.order.getPriceTotalWithAdds(), 0) }}</span>
          <v-btn color="white" icon class="ml-1" @click="cancel()" :title="$t('Cancel')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="cobro__resumen">
          <div class="cobro__dato cobro__dato--puntos" v-if="activePoints()">
            <span class="cobro__etiqueta">{{ $t("discount_points") }}</span>
            <span class="cobro__valor">{{ $filters.currency(this.order.getTotalPointsDiscount($store), 0) }}</span>
          </div>
          <div class="cobro__dato cobro__dato--pagado">
            <span class="cobro__etiqueta">{{ $t("paid") }}</span>
            <span class="cobro__valor">{{ $filters.currency(this.order.getTotalPayments(), 0) }}</span>
          </div>
          <div class="cobro__dato" :class="order.getBalance() > 0 ? 'cobro__dato--saldo' : 'cobro__dato--pagado'">
            <span class="cobro__etiqueta">{{ $t("balance") }}</span>
            <span class="cobro__valor">{{ $filters.currency(this.order.getBalance(), 0) }}</span>
          </div>
        </div>

        <v-card-text class="pa-0 cobro__cuerpo">
          <v-tabs :vertical="!is_mobile" show-arrows class="cobro__metodos">
            <v-tab
              key="points"
              class="font-weight-medium body-2"
              v-if="activePoints()"
            >
              {{ $t("points") }}
            </v-tab>
            <template v-for="(pm, category) in paymentMethods">
              <template v-if="category == 'default'">
                <v-tab
                  v-for="pay in paymentMethods[category]"
                  :key="pay.id"
                  class="font-weight-medium body-2"
                >
                  {{ pay.name }}
                </v-tab>
              </template>
            </template>
            <v-tab key="digital_wallet" class="font-weight-medium body-2">
              {{ $t("digital_wallet") }}
            </v-tab>
            <v-tab key="platform" class="font-weight-medium body-2">
              {{ $t("platform") }}
            </v-tab>
            <v-tab key="payment_gateway" class="font-weight-medium body-2">
              {{ $t("payment_gateway") }}
            </v-tab>

            <v-tab class="font-weight-medium body-2 cobro__lista">
              <v-badge
                color="green"
                inline
                :content="countPayments()"
                :value="countPayments()"
              >
                {{ $t("payment_list") }}
              </v-badge>
            </v-tab>
            <v-tab-item key="points" v-if="activePoints()">
              <CartPaymentsPoints :order="order" />
            </v-tab-item>
            <template v-for="(pm, category) in paymentMethods">
              <template v-if="category == 'default'">
                <v-tab-item v-for="pay in pm" :key="pay.id">
                  <v-card flat>
                    <CartPaymentGiftCardKeyboard
                      :paymentMethod="pay"
                      v-if="pay.code == 'tarjeta_regalo'"
                      :order="order"
                      :is_mobile="is_mobile"
                    ></CartPaymentGiftCardKeyboard>
                    <CartPaymentsKeyboard
                      :paymentMethod="pay"
                      v-else
                      :order="order"
                      :is_mobile="is_mobile"
                    ></CartPaymentsKeyboard>
                  </v-card>
                </v-tab-item>
              </template>
            </template>

            <v-tab-item key="digital_wallet">
              <v-card flat>
                <CartPaymentsKeyboardCategory
                  :paymentMethods="paymentMethods['digital_wallet']"
                  :order="order"
                  :is_mobile="is_mobile"
                ></CartPaymentsKeyboardCategory>
              </v-card>
            </v-tab-item>
            <v-tab-item key="platform">
              <v-card flat>
                <CartPaymentsKeyboardCategory
                  :paymentMethods="paymentMethods['platform']"
                  :order="order"
                  :is_mobile="is_mobile"
                ></CartPaymentsKeyboardCategory>
              </v-card>
            </v-tab-item>
            <v-tab-item key="payment_gateway">
              <v-card flat>
                <CartPaymentsKeyboardCategory
                  :paymentMethods="paymentMethods['payment_gateway']"
                  :order="order"
                  :is_mobile="is_mobile"
                ></CartPaymentsKeyboardCategory>
              </v-card>
            </v-tab-item>

            <v-tab-item class="pa-1">
              <v-container>
                <v-card>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="headers"
                      :items="order.getPayments()"
                      sort-by="_id"
                      class="contact-listing-app"
                    >
                      <!-- eslint-disable-next-line -->
                      <template v-slot:item.payment_method="{ item }">
                        {{ item.payment_method.name }}
                      </template>
                      <!-- eslint-disable-next-line -->
                      <template v-slot:item.value="{ item }">
                        {{ $filters.currency(item.value, 0) }}
                      </template>
                      <!-- eslint-disable-next-line -->
                      <template v-slot:item.date="{ item }">
                        {{ $filters.date(item.date, "DD-MMM-YYYY") }}
                      </template>
                      <!-- eslint-disable-next-line -->
                      <template v-slot:item.acc_income_id="{ item }">
                        <v-icon
                          class="green--text"
                          v-if="item.acc_income_id"
                          :title="$t('synchronized')"
                        >
                          mdi-sync
                        </v-icon>
                        <v-icon
                          class="red--text"
                          :title="$t('no_synchronized')"
                          v-else
                        >
                          mdi-sync-alert
                        </v-icon>
                      </template>
                      <!-- eslint-disable-next-line -->
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          icon
                          dark
                          v-if="!item.acc_income_id"
                          :title="$t('delete')"
                          @click="deletePayment(item)"
                        >
                          <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:no-data>
                        {{ $t("no_items") }}
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="cobro__pie">
          <v-switch
            prepend-icon="mdi-printer"
            v-model="printReceiptSwitch"
            inset
            :label="printerOption()"
          ></v-switch>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!orderFinalized && order.getTotalItems() > 1"
            outlined
            color="primary"
            class="mr-3"
            :disabled="cobrando || !(order.getBalance() > 0)"
            title="Cada cliente paga lo suyo"
            @click="separarAbierto = true"
          >
            <v-icon left>mdi-call-split</v-icon>Separar cuenta
          </v-btn>
          <v-btn
            dark
            color="primary"
            outlined
            @click="cancel()"
            :title="$t('Cancel')"
          >
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn
            v-if="!orderFinalized || cobrando"
            color="primary"
            :loading="cobrando"
            :disabled="cobrando || this.order.getBalance() > 0"
            @click="toPay()"
            :title="$t('to_pay')"
          >
            {{ $t("to_pay") }}
          </v-btn>
          <v-btn
            v-if="orderFinalized && !cobrando"
            color="primary"
            @click="printReceipt()"
            :title="$t('print_receipt')"
          >
            {{ $t("print_receipt") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <SepararCuenta v-model="separarAbierto" :order="order" :paymentMethods="paymentMethods" />
      <ReminderActivateCards ref="reminderActivateCards" />
    </v-dialog>
  </div>
</template>
<script>
import CartPaymentsKeyboard from "./CartPaymentsKeyboard";
import CartPaymentGiftCardKeyboard from "./CartPaymentGiftCardKeyboard";
import CartPaymentsKeyboardCategory from "./CartPaymentsKeyboardCategory";
import CartPaymentsPoints from "./CartPaymentsPoints";
import MixinConfirm from "./../../../mixins/MixinConfirm";
import ReminderActivateCards from "./ReminderActivateCards";
import SepararCuenta from "./SepararCuenta.vue";
export default {
  name: "CartPayments",
  components: {
    CartPaymentsKeyboard,
    CartPaymentGiftCardKeyboard,
    CartPaymentsKeyboardCategory,
    CartPaymentsPoints,
    ReminderActivateCards,
    SepararCuenta,
  },
  mixins: [MixinConfirm],
  data: () => ({
    orderFinalized: false,
    separarAbierto: false,
    cobrando: false,
    searched: false,
    invalid: true,
    printReceiptSwitch: true,
    key: 0,
    paymentMethods: [],
    dialogDelete: false,
    headers: [],
    modalErrorSaveOrder: false,
    errorSaveOrder: "",
  }),
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    order: Object,
    is_mobile: Boolean,
  },
  //props: ['customer'],

  mounted() {
    /*if(this.customer){
      setTimeout(() => {


      this.item = JSON.parse(JSON.stringify(this.customer));
      this.searched = true;
      this.key++;
      }, 250)
    }*/
    this.getPaymentMethods();
    this.getValuePrintAutomatic();

    this.headers = [
      { text: this.$t("name"), value: "payment_method" },
      { text: this.$t("value"), value: "value" },
      { text: this.$t("date"), value: "date" },
      { text: this.$t("status"), value: "acc_income_id", sortable: false },
      { text: this.$t("actions"), value: "actions", sortable: false },
    ];
  },
  methods: {
    async getValuePrintAutomatic() {
      let installation = this.$store.getters.installation;
      if (installation) {
        const cashRegister = await this.$db.getCashRegister(
          installation.cash_id
        );
        if (cashRegister) {
          if (cashRegister.config) {
            console.log(cashRegister);
            if (
              typeof cashRegister.config.pos_active_print_receipt_automatic ==
              "boolean"
            ) {
              this.printReceiptSwitch =
                cashRegister.config.pos_active_print_receipt_automatic;
            }
          }
        }
      }
    },
    activePoints() {
      let activeModulePoints = this.$store.getters.getGeneralValue(
        "gen_others_active_point_accumulation"
      );

      let hasCustomer = !!this.order.data_customer;
      return activeModulePoints && hasCustomer;
    },
    hasGiftCards() {
      let order = this.$pos.getCurrentOrder();
      let items = order.getItems(true);
      if (items && items.length > 0) {
        for (const item of items) {
          if (item && item.product && item.product.product_type == "gift") {
            return true;
          }
        }
      }
      return false;
    },
    async revisarTarjetasDeRegalo() {
      const pagos = this.order.getPayments().filter((p) => p.payment_method && p.payment_method.code === "tarjeta_regalo");
      if (!pagos.length) {
        return null;
      }
      const porCodigo = {};
      pagos.forEach((p) => {
        const codigo = String(p.reference || "").trim().toUpperCase();
        porCodigo[codigo] = (porCodigo[codigo] || 0) + Number(p.value || 0);
      });
      for (const [codigo, valor] of Object.entries(porCodigo)) {
        let res = null;
        try {
          res = await this.$http.post("api/v1/gift-card/get-balance", { code: codigo }, true, false);
        } catch (e) {
          res = null;
        }
        if (!res || !res.success) {
          return "Para cobrar con una tarjeta de regalo hace falta conexión a internet: no se puede comprobar el saldo de la tarjeta " + codigo + ".";
        }
        if (Number(res.balance) < valor) {
          return "La tarjeta " + codigo + " ya no tiene saldo suficiente (saldo: " + res.balance + ").";
        }
      }
      return null;
    },
    async toPay() {
      if (this.orderFinalized || this.cobrando) {
        return; // ya se está cobrando: un segundo clic no debe guardar otra vez
      }
      this.cobrando = true;
      try {
        this.orderFinalized = true;
        // Una tarjeta de regalo es dinero: se comprueba el saldo en el servidor justo antes de cobrar. Sin internet no se puede
        // (la caja de escritorio guardaría la venta y la subiría después, y la tarjeta pudo gastarse en otra caja).
        const bloqueoTarjeta = await this.revisarTarjetasDeRegalo();
        if (bloqueoTarjeta) {
          this.orderFinalized = false;
          this.$store.commit("setError", bloqueoTarjeta);
          return;
        }
        let order = this.$pos.getCurrentOrder();
        // se modifica para que la orden pueda salir en las pantallas de cocina
        // si esta activo
        // if (order.order_status === "created") {
        //   this.$pos.setOrderStatus(this.$pos.getCurrentOrder(), "received");
        // } else {
        //   // si se realiza el pago desde cualquier otro estado se cierra la orden
        //   this.$pos.setOrderStatus(this.$pos.getCurrentOrder(), "closed");
        // }
        // Si el cobro no llega al servidor la orden vuelve a como estaba, para reintentar (ver `reabrir`).
        const actual = this.$pos.getCurrentOrder();
        this.antesDeCobrar = { orden: actual, estado: actual.order_status, abierta: actual.is_open, cierre: actual.closing_date };
        this.$pos.setOrderStatus(this.$pos.getCurrentOrder(), "closed");

        this.$pos.setIsOpen(this.$pos.getCurrentOrder(), false);
        this.$pos.setClosingDate(
          this.$pos.getCurrentOrder(),
          this.$filters.datetime(new Date())
        );
        let response = await this.$pos.saveOrder(
          this.$pos.getCurrentOrder(),
          this.$http,
          true
        );
        if (response.success) {
          if (response.item) {
            if (response.item.invoice_id) {
              this.$pos.setInvoiceId(
                this.$pos.getCurrentOrder(),
                response.item.invoice_id
              );
            }
          }
          if (this.printReceiptSwitch) {
            // this.printReceipt();
            this.$pos.printOrderServer(response.item);
          }
        } else {
          if (response.code == 9780) {
            this.orderFinalized = false;

            let message =
              "Esta orden ya fue pagada anteriormente con el consecutivo " +
              response.consecutive +
              ", por favor verificala antes de volver a facturar, si deseas procesarla presiona confirmar";
            const confirm = await this.openConfirm(message);
            if (confirm) {
              this.$pos.getCurrentOrder().id = null;
              this.$pos.getCurrentOrder().data_order_trace = [
                { pre_order: response.consecutive },
              ];
              this.$pos.getCurrentOrder().local_reference = this.$pos
                .getCurrentOrder()
                .createReference();
            } else {
              this.$pos.createOrder();
              this.$store.dispatch("createdOrder");
            }
          } else {
            this.reabrir();
            this.errorSaveOrder = response.msg;
            this.showModalErrorSaveOrder();
          }
        }

        //this.$pos.syncOrder
        // (this.$pos.getCurrentOrder())
        /* */
        /*if (this.$pos.getCurrentOrder().getIsOnTable()) {
          let name_table = this.$pos.getCurrentOrder().getNameTable();
          if (name_table) {
            let table = await this.$db.getTableByName(name_table);
            await this.$db.updateTableBusy(table, false);
          }
        }*/
      } catch (e) {
        // Sin respuesta del servidor la venta no quedó cobrada aquí: «Imprimir recibo» y «Cancelar» borraban el
        // carrito y el cliente se iba sin factura. Vuelve a «Pagar»; si sí llegó, el servidor contesta 9780 al reintentar.
        // El aviso general del POS ya salió («Ha ocurrido un error»): se cambia por uno que dice qué hacer, sin abrir otro encima.
        this.reabrir();
        this.$store.commit("setError", "No se pudo confirmar el cobro con el servidor. Revisa la conexión y vuelve a pulsar «Pagar».");
        console.error(e);
        return null;
      } finally {
        this.cobrando = false;
      }

      /*
      const obj = JSON.parse(JSON.stringify(this.item));
      this.clear();
      this.searched = false;  		
      this.$emit('selected', obj);
      this.key++;*/
      // this.paidOut = true;
    },
    /** La orden vuelve a como estaba antes de «Pagar»: abierta, con sus pagos, para reintentar el cobro. */
    reabrir() {
      this.orderFinalized = false;
      const antes = this.antesDeCobrar;
      if (antes && antes.orden === this.$pos.getCurrentOrder()) {
        this.$pos.setOrderStatus(antes.orden, antes.estado);
        this.$pos.setIsOpen(antes.orden, antes.abierta);
        this.$pos.setClosingDate(antes.orden, antes.cierre);
      }
      this.antesDeCobrar = null;
    },
    async cancel() {
      this.searched = false;
      this.key++;
      if (this.orderFinalized) {
        this.$refs.reminderActivateCards.renderItem(this.hasGiftCards());
      }
      this.getValuePrintAutomatic();
      this.$emit("cancel", { orderfinalized: this.orderFinalized });
      this.clear();
    },
    cancelError() {
      this.searched = false;
      this.key++;
      this.getValuePrintAutomatic();
      this.$emit("cancelError");
      this.clear();
    },
    clear() {
      if (this.orderFinalized) {
        this.orderFinalized = false;
      }
    },
    countPayments() {
      return this.order.getPayments().length;
    },
    deletePayment(payment) {
      this.openConfirm(this.$t("are_you_sure_delete_this_item")).then(
        (response) => {
          if (response) {
            this.$pos.deletePayment(payment);
          }
        }
      );
    },
    searchClient() {
      if (this.item.identification) {
        this.$http
          .get(
            "api/v1/list/client-by-document",
            { name: this.item.identification },
            true,
            false
          )
          .then((response) => {
            if (response.success) {
              if (response.items && response.items.length == 1) {
                this.item = response.items[0];
              }
            }
            this.searched = true;
          })
          .catch((e) => {
            this.searched = true;
          });
      }
    },
    async getPaymentMethods() {
      const payment_methods = await this.$db.getPaymentMethods();
      this.paymentMethods = payment_methods;

      let mapByCategory = {};
      for (const pm of this.paymentMethods) {
        if (!mapByCategory[pm.category]) {
          mapByCategory[pm.category] = [];
        }
        mapByCategory[pm.category].push(pm);
      }
      this.paymentMethods = mapByCategory;
    },
    printerOption() {
      if (this.printReceiptSwitch) {
        return this.$t("print");
      }
      return this.$t("no_print");
    },
    print() {},
    printReceipt() {
      this.$pos.printReceipt(this.$pos.getCurrentOrder());
    },
    showModalErrorSaveOrder() {
      this.modalErrorSaveOrder = true;
    },
    closeModalErrorSaveOrder() {
      this.modalErrorSaveOrder = false;
      this.cancelError();
    },
  },
};
</script>
<style>
/* En pantallas bajas (POS táctil de 1024x768) el cuerpo se desplaza y el pie con Cancelar/Pagar queda siempre a la vista. */
.cobro__tarjeta {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
}
.cobro__tarjeta > .cobro__cuerpo {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.cobro__tarjeta > .cobro__encabezado,
.cobro__tarjeta > .cobro__resumen,
.cobro__tarjeta > .cobro__pie {
  flex: 0 0 auto;
}
.grid_ss {
  border-left: 4px solid var(--v-secondary-base) !important;
}
.cobro__encabezado {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 8px 0 16px;
  color: #fff;
  background: var(--pos-encabezado);
}
.cobro__titulo {
  font-size: 1.2rem;
  font-weight: 500;
}
.cobro__total {
  font-size: 1.5rem;
  font-weight: 700;
}
.cobro__resumen {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  background: #f6f7f8;
}
.cobro__dato {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  padding: 8px 14px;
  border-radius: 10px;
  background: #fff;
  border: 1.5px solid rgba(0, 0, 0, 0.1);
}
.cobro__etiqueta {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(0, 0, 0, 0.6);
}
.cobro__valor {
  font-size: 1.35rem;
  font-weight: 700;
}
.cobro__dato--pagado {
  border-color: #43a047;
  background: #e8f5e9;
}
.cobro__dato--pagado .cobro__valor {
  color: #2e7d32;
}
.cobro__dato--saldo {
  border-color: #e57373;
  background: #fdecea;
}
.cobro__dato--saldo .cobro__valor {
  color: #c62828;
}
.cobro__dato--puntos {
  border-color: var(--v-primary-base);
}
@media (max-width: 599px) {
  .cobro__pie {
    flex-wrap: wrap;
    row-gap: 0;
  }
  .cobro__pie .v-input--switch {
    flex: 1 0 100%;
    margin-top: 0;
    padding-top: 0;
  }
  .cobro__pie .v-input__slot {
    margin-bottom: 0;
  }
  .cobro__pie .spacer {
    display: none;
  }
  .cobro__pie .v-btn {
    flex: 1 1 0;
  }
  .cobro__titulo {
    font-size: 1rem;
    white-space: nowrap;
  }
  .cobro__resumen {
    padding: 8px 10px;
    gap: 6px;
  }
  .cobro__dato {
    padding: 6px 10px;
  }
  .cobro__valor {
    font-size: 1.05rem;
  }
  .cobro__total {
    font-size: 1.2rem;
  }
}
.cobro__metodos.v-tabs--vertical > .v-tabs-bar .v-tab {
  justify-content: flex-start;
  text-align: left;
  text-transform: none;
  letter-spacing: 0;
  padding: 0 16px;
}
.cobro__metodos.v-tabs--vertical > .v-tabs-bar .v-tab--active {
  background: rgba(36, 169, 225, 0.1);
  font-weight: 600 !important;
}
.cobro__metodos.v-tabs--vertical > .v-tabs-bar .cobro__lista {
  margin-top: 8px;
  border-top: 1px solid rgba(46, 125, 50, 0.35);
  border-radius: 0;
  background: #e8f5e9;
  color: #2e7d32 !important;
  font-weight: 600 !important;
}
.cobro__metodos.v-tabs--vertical > .v-tabs-bar .cobro__lista.v-tab--active {
  background: #c8e6c9;
}
/* Al escribir el monto el campo no debe correr el contenido hacia un lado. */
.cobro__metodos .v-window {
  overflow-x: clip;
}
</style>